import { makeAutoObservable, runInAction } from 'mobx';
import axios, { CancelTokenSource } from 'axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

export interface IOrganization {
  displayName: string;
  name: string;
  profileImage?: string;
  academyLink?: string;
  backofficeUrl?: string;
  faqLink?: string;
  allowedActions?: string[];
  adminAccess?: boolean;
  isWorkspaceAdminInOrg?: boolean;
  // TODO: Create org allowed actions
}

export interface IAuthStore {
  authExpiration?: number;
  isLoading: boolean;
  cancelSource: CancelTokenSource;
  newCancelSource(): void;
  reAuth(): Promise<void>;
}

export default class AuthStore implements IAuthStore {
  isLoading = true;
  authExpiration?: number;
  cancelSource = axios.CancelToken.source();

  constructor() {
    makeAutoObservable(this);
  }

  newCancelSource() {
    runInAction(() => {
      this.cancelSource = axios.CancelToken.source();
    });
  }

  async reAuth() {
    await axios.get('/api/refresh_auth_token');

    runInAction(() => {
      this.authExpiration = cookies.get('auth_timeout');
    });
  }
}
